<template>
  <div class="text-caption">
    <!--    <span v-if="media" class="mr-2">-->
    <!--      <v-icon size="16" color="primary">-->
    <!--        perm_media-->
    <!--      </v-icon>-->
    <!--    </span>-->
    <span v-for="(field, i) in this.customFieldsData" :key="i" class="mr-1">
      <v-tooltip v-model="field.tooltipShow" bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-icon size="16" color="primary">{{ field.icon }}</v-icon>
            {{ field.value }}
          </span>
        </template>
        <span>{{ field.title }}</span>
      </v-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    customFieldsData: {
      type: Array,
      default: () => null,
    },
    // media: {
    //   type: Object,
    //   default: () => null,
    // },
  },
  beforeMount() {
    this.customFieldsData.map(item => (item.tooltipShow = false))
  },
}
</script>

<style scoped></style>
